export const IMAGE_URL = `${process.env.REACT_APP_IMAGE_URL}/seller/`;
export const JOIN = `${process.env.REACT_APP_APP_API_URL}/api/auth/registerForBuyer`